<template>
    <!--选择资源-->
    <el-dialog :visible.sync="openStatus" class="choose-resource-container" :title="$t('eip.text.chooseSource')"
        @close="doClose" :close-on-click-modal="false">
        <el-form ref="ruleForm" label-width="150px">
            <!--资源类型-->
            <el-form-item :label="$t('eip.text.sourceType') | withColon">
                <el-radio-group v-model="selectedType" @change="changeSelectedType">
                    <el-radio-button v-for="(item) in sourceTypes" :key="item.key" :label="item.key">
                        {{ item.label }}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            <div v-if="selectedType === 'cps'">
                <!--网口数量-->
                <el-form-item :label="$t('eip.text.internetAccessType') | withColon">
                    <el-radio-group v-model="selectInternetAccessType" @change="changeInternetAccessType">
                        <el-radio-button v-for="item in internetAccessTypes" :key="item.label" :label="item.label">
                            {{ item.value }}
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <!--目标网络接口名称-->
                <el-form-item :label="$t('eip.text.targetInternetAccessName') | withColon">
                    <span v-if="selectInternetAccessType === 'bond'">
                        {{ $t('eip.text.singleInternetAccessChiefName') }}
                    </span>
                    <el-radio-group v-else v-model="selectTargetInternetAccessName"
                        @change="changeTargetInternetAccessName">
                        <el-radio-button v-for="item in targetInternetAccessNames" :key="item.label" :label="item.label">
                            {{ item.value }}
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </div>
            <div v-if="selectedType === 'game'">
                <!--网口数量-->
                <el-form-item :label="$t('eip.text.internetAccessType') | withColon">
                    <el-radio-group v-model="selectGameInternetAccessType">
                        <el-radio-button v-for="item in gameInternetAccessTypes" :key="item.label" :label="item.label">
                            {{ item.value }}
                        </el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <!--目标网络接口名称-->
                <el-form-item :label="$t('eip.text.targetInternetAccessName') | withColon">
                    <span>主网口(eth0)</span>
                </el-form-item>
            </div>
        </el-form>
        <!--下拉搜索条件-->
        <div style="margin-left:50px">
            <div class="jc-container-table">
                <div class="jc-container-table-actionBar jc-box-table-search">
                    <el-input style="height:30px;width:412px" @keyup.enter.native="filterBySearchValue"
                        :placeholder="currentPlaceholder" v-model="currentSearchValue">
                        <el-select style="width:100px" slot="prepend" id="my-select" v-model="currentSearch"
                            @change="changeSearch" :placeholder="$t('listPage.placeholder.choose')">
                            <el-option class="my-select-input" v-for="item in selectedSearchSelect" :key="item.searchValue"
                                :label="item.searchLabel" :value="item.searchValue"></el-option>
                        </el-select>
                        <el-button slot="append" icon="jc-icon-search" class="search-icon"
                            @click="filterBySearchValue"></el-button>
                    </el-input>
                </div>
            </div>

            <!--游戏服务器实例列表-->
            <el-table :data="vpcListData" v-if='selectedType === "game"' v-loading="refreshLoading" max-height="250"
                :empty-text="$t('speechCraft.listEmptyText')" :row-class-name="tableRowClassName" style="width: 100%">
                <el-table-column width="30">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedVpcId" :label='scope.row.instanceId' class="label-hidden">
                        </el-radio>
                    </template>
                </el-table-column>
                <!--名称-->
                <el-table-column :label="$t('subnet.text.name')" min-width="150">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.name" class="item" effect="dark">
                            <span>{{ scope.row.name | maybeEmpty }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!--ID-->
                <el-table-column :label="$t('eip.text.id')" min-width="250">
                    <template slot-scope="scope">
                        <span>{{ scope.row.instanceId | maybeEmpty }}</span>
                    </template>
                </el-table-column>
                <!--目标内网IP地址-->
                <el-table-column :label="$t('eip.text.targetPrivateIpAddress')" min-width="175">
                    <template slot-scope="scope">
                        <span>
                            <el-select v-model="scope.row.selectedIpAddress" filterable
                                @change="changeSelectedIpAddress(scope.row)"
                                @visible-change="value => getAvailablePrivateIps(value, scope.row)"
                                popper-class="ip-address-select" :no-data-text="$t('subnet.text.noAvailableIpAddress')"
                                :placeholder="$t('eip.help.ipAddressSearch')">
                                <el-option v-for="item in scope.row.ipAddressOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </span>
                    </template>
                </el-table-column>
                <!--创建时间-->
                <el-table-column :label="$t('detail.text.createTime')" min-width="150">
                    <template slot-scope="scope">
                        <span>{{ scope.row.charge ? scope.row.charge.chargeStartTime : '' | maybeEmpty }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <!--VPC实例列表-->
            <el-table :data="vpcListData" v-if='selectedType === "cps"' v-loading="refreshLoading" max-height="250"
                :empty-text="$t('speechCraft.listEmptyText')" :row-class-name="tableRowClassName" style="width: 100%">
                <el-table-column width="30">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedVpcId" :label='scope.row.instanceId' class="label-hidden">
                        </el-radio>
                    </template>
                </el-table-column>
                <!--名称-->
                <el-table-column :label="$t('subnet.text.name')" min-width="150">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.name" class="item" effect="dark">
                            <span>{{ scope.row.name | maybeEmpty }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!--ID-->
                <el-table-column :label="$t('eip.text.id')" min-width="250">
                    <template slot-scope="scope">
                        <span>{{ scope.row.instanceId | maybeEmpty }}</span>
                    </template>
                </el-table-column>
                <!--目标内网IP地址-->
                <el-table-column :label="$t('eip.text.targetPrivateIpAddress')" min-width="175">
                    <template slot-scope="scope">
                        <span>
                            <el-select v-model="scope.row.selectedIpAddress" filterable
                                @change="changeSelectedIpAddress(scope.row)"
                                @visible-change="value => getAvailablePrivateIps(value, scope.row)"
                                popper-class="ip-address-select" :no-data-text="$t('subnet.text.noAvailableIpAddress')"
                                :placeholder="$t('eip.help.ipAddressSearch')">
                                <el-option v-for="item in scope.row.ipAddressOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </span>
                    </template>
                </el-table-column>
                <!--创建时间-->
                <el-table-column :label="$t('detail.text.createTime')" min-width="150">
                    <template slot-scope="scope">
                        <span>{{ scope.row.charge ? scope.row.charge.chargeStartTime : '' | maybeEmpty }}</span>
                    </template>
                </el-table-column>
            </el-table>

            <!--负载均衡实例列表-->
            <el-table :data="slbListData" v-if='selectedType === "slb"' v-loading="refreshLoading" max-height="250"
                :empty-text="$t('speechCraft.listEmptyText')" :row-class-name="tableRowClassName" style="width:100%">
                <el-table-column min-width="30">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedLbId" :label='scope.row.loadBalancerId'
                            :disabled="scope.row.elasticIpId !== undefined" class="label-hidden"></el-radio>
                    </template>
                </el-table-column>
                <!--实例名称-->
                <el-table-column :label="$t('slb.text.slbName')" min-width="150">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.name">
                            <span>{{ scope.row.name | maybeEmpty }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!--实例ID-->
                <el-table-column :label="$t('slb.text.slbId')" min-width="250">
                    <template slot-scope="scope">
                        <span>{{ scope.row.loadBalancerId | maybeEmpty }}</span>
                    </template>
                </el-table-column>
                <!--创建时间-->
                <el-table-column :label="$t('detail.text.createTime')" min-width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.createTime">{{ getCreateTime(scope.row.createTime) | maybeEmpty }}</span>
                        <span v-else>{{ scope.row.charge ? scope.row.charge.chargeStartTime : '' | maybeEmpty }}</span>
                        <!-- <span>{{ scope.row.charge ? scope.row.charge.chargeStartTime : '' | maybeEmpty }}</span> -->
                    </template>
                </el-table-column>
            </el-table>

            <!--nat网关列表-->
            <el-table :data="natListData" v-if='selectedType === "nat"' v-loading="refreshLoading" max-height="250"
                :empty-text="$t('speechCraft.listEmptyText')" :row-class-name="tableRowClassName" style="width:100%">
                <el-table-column min-width="30">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedNatId" :label='scope.row.natGatewayId'
                            :disabled="scope.row.elasticIpId !== undefined" class="label-hidden"></el-radio>
                    </template>
                </el-table-column>
                <!--实例名称-->
                <el-table-column :label="$t('slb.text.slbName')" min-width="150">
                    <template slot-scope="scope">
                        <el-tooltip :content="scope.row.name">
                            <span>{{ scope.row.name | maybeEmpty }}</span>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!--实例ID-->
                <el-table-column :label="$t('slb.text.slbId')" min-width="250">
                    <template slot-scope="scope">
                        <span>{{ scope.row.natGatewayId | maybeEmpty }}</span>
                    </template>
                </el-table-column>
                <!--创建时间-->
                <el-table-column :label="$t('detail.text.createTime')" min-width="150">
                    <template slot-scope="scope">
                        <span>{{ scope.row.charge ? scope.row.charge.chargeStartTime : '' | maybeEmpty }}</span>
                    </template>
                </el-table-column>
            </el-table>

        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="doClose">{{ $t('detail.text.cancel') }}</el-button>
            <el-button @click="doConfirm" type="primary"
                :disabled="(!selectedVpcId || !selectedVpcData.selectedIpAddress) && !selectedLbId && !selectedNatId" :loading="sureLoading">
                {{ $t('detail.text.sure') }}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
import {
    NetworkTypeConstant,
    EIPAssociateConstant,
    EnableInternetConstant,
    TargetIpAddressChannelConstant
} from '@/common/Constants';
import { deepCopy } from '@/common/tool'
import dayjs from 'dayjs'
export default {
    data() {
        const initPage = 1;
        return {
            sureLoading: false,
            sourceTypes: [
                {
                    key: 'cps',
                    label: this.$t('eip.text.cps')
                },
                {
                    key: 'game',
                    label: this.$t('game.title')
                },
                {
                    key: 'slb',
                    label: this.$t('slb.text.slb')
                },
                {
                    key: 'nat',
                    label: this.$t('nat.text.nat')
                },
            ],
            // 默认选中云物理服务器
            selectedType: 'cps',
            //网口数量
            internetAccessTypes: [{
                label: 'bond',
                value: this.$t('eip.text.singleInternetAccess')
            }, {
                label: 'dual',
                value: this.$t('eip.text.doubleInternetAccess')
            }],
            gameInternetAccessTypes: [{
                label: 'bond',
                value: this.$t('eip.text.singleInternetAccess')
            }],
            selectInternetAccessType: 'bond',
            selectGameInternetAccessType: 'bond',
            //目标网络接口名称
            targetInternetAccessNames: [
                {
                    label: 'chief',
                    value: this.$t('eip.text.singleInternetAccessChiefName')
                }
            ],
            selectTargetInternetAccessName: 'chief',
            openStatus: false,
            // 当前搜索条件
            currentSearch: 'name',
            // 当前搜索input框值
            currentSearchValue: '',
            // 当前搜索条件对应placeholder
            currentPlaceholder: this.$t('eip.placeholder.search.name'),
            // 查询到的VPC列表数据
            vpcListData: [],
            // 查询到的GAME列表数据
            gameListData: [],
            // 查询到的SLB列表数据
            slbListData: [],
            // 查询到的NAT网关列表数据
            natListData: [],
            // 表格加载中状态
            refreshLoading: true,
            // VPC列表总数
            total: 0,
            pageSize: 20,
            currentPage: initPage,
            // radio选择的VPC ID
            selectedVpcId: '',
            // radio选择的VPC实例数据
            selectedVpcData: {},
            // 当前选择的实例下的可用私有IP列表数据
            ipAddressOptions: [],
            // radio选择的LB ID
            selectedLbId: '',
            // radio选择的NAT ID
            selectedNatId: '',
            selectedSearchSelect: [
                {
                    searchValue: 'name',
                    searchLabel: this.$t('subnet.text.name')
                },
                {
                    searchValue: 'id',
                    searchLabel: this.$t('slb.text.slbId')
                }
            ]
        };
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: true,
        },
        region: {
            type: String,
            default: ''
        },
        eipId: {
            type: String,
            default: ''
        }
    },
    computed: {
        NetworkTypeConstant: () => NetworkTypeConstant,
        EIPAssociateConstant: () => EIPAssociateConstant,
        EnableInternetConstant: () => EnableInternetConstant,
        TargetIpAddressChannelConstant: () => TargetIpAddressChannelConstant
    },
    watch: {
        dialogVisible(val) {
            this.openStatus = val;
            if (!val) {
                return
            }
            this.selectInternetAccessType = 'bond';
            this.getDifferentListDataBySelectedRadio()
        },
        region() {
            //this.getDifferentListDataBySelectedRadio();
        },
        selectedVpcId(newVal, oldVal) {
            let vpcListData = deepCopy(this.vpcListData);
            vpcListData.map((item, index) => {
                item.selectedIpAddress = '';
            })
            this.vpcListData = vpcListData;
            this.selectedVpcData.selectedIpAddress = '';
        }
    },

    mounted() {
        //this.getDifferentListDataBySelectedRadio();
    },

    methods: {
        getCreateTime(createTime) {
            if (!createTime) return '';
            return dayjs(createTime).format('YYYY-MM-DD HH:mm:ss');
        },
        // 切换网络接口数量
        changeInternetAccessType(label) {
            if (label === 'bond') {
                this.targetInternetAccessNames = [{
                    label: 'chief',
                    value: this.$t('eip.text.singleInternetAccessChiefName')
                }];
            } else if (label === 'dual') {
                this.targetInternetAccessNames = [{
                    label: 'chief',
                    value: this.$t('eip.text.chiefInternetAccessName')
                },
                {
                    label: 'sub',
                    value: this.$t('eip.text.subInternetAccessName')
                }];
            }
            this.getVpcListData();
        },
        // 切换目标网络接口名称
        changeTargetInternetAccessName(label) {
            let vpcListData = deepCopy(this.vpcListData);
            vpcListData.map((item, index) => {
                item.selectedIpAddress = '';
            })
            this.vpcListData = vpcListData;
            this.selectedVpcData.selectedIpAddress = '';
        },
        // 获取当前实例的可用的私有IP列表
        getAvailablePrivateIps(isVisible, row) {
            if (!isVisible) {
                return
            }
            let index = row.index;
            let params = {
                region: row.region,
                instanceId: row.instanceId,
                subnetId: this.selectTargetInternetAccessName === 'chief' ? row.subnetId : row.extensionSubnetId,
                channel: TargetIpAddressChannelConstant.EIP
            }
            Ajax.get('/api/cps/availablePrivateIps', params)
                .then((res) => {
                    let vpcListData = deepCopy(this.vpcListData);
                    vpcListData[index].ipAddressOptions = [];
                    for (const item of res.data.availablePrivateIps) {
                        const formattedItem = {
                            value: item,
                            label: ''
                        };
                        if (item === row.privateIp || item === row.extensionPrivateIp) {
                            formattedItem.label = `${item}(${this.$t('privateNetInstance.intranetIp')})`;
                        } else {
                            formattedItem.label = `${item}(${this.$t('subnet.text.ipAlias')})`;
                        }
                        vpcListData[index].ipAddressOptions.push(formattedItem);
                    }
                    this.vpcListData = vpcListData;
                })
                .catch()
                .finally();
        },
        // 关闭弹框
        doClose() {
            this.doReset('ruleForm');
            this.currentSearchValue = ''
            this.currentSearch = 'name'
            this.$emit('ifDialogVisible', false);
        },
        // 点击确认按钮，绑定资源
        doConfirm() {
            this.sureLoading = true;
            const params = {
                region: this.region,
            };
            let tempParams = {}
            let url = '';
            let bindRequest;
            if (this.selectedType === 'slb') {
                tempParams = Object.assign(params, { loadBalancerId: this.selectedLbId, elasticIpId: this.eipId })
                url = '/api/cps/slbs/associateElasticIp'
                bindRequest = Ajax.put(url, tempParams)
            } else if (this.selectedType === 'cps' || this.selectedType === 'game') {
                tempParams = Object.assign(params, {
                    elasticIpId: this.eipId,
                    instanceId: this.selectedVpcId,
                    targetIp: this.selectedVpcData.selectedIpAddress,
                    subnetId: this.selectTargetInternetAccessName === 'chief' ? this.selectedVpcData.subnetId : this.selectedVpcData.extensionSubnetId
                });
                url = '/api/cps/associateElasticIp'
                bindRequest = Ajax.put(url, tempParams)
            } else if (this.selectedType === 'nat') {
                tempParams = Object.assign(params, {
                    az: this.az,
                    natGatewayId: this.selectedNatId,
                    eipIds: [this.eipId],
                    clientToken: Normal.getClientToken(),
                    type: this.EIPAssociateConstant.ASSOCIATE
                })
                url = '/api/cps/nat/operateBind'
                bindRequest = Ajax.put(url, tempParams, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            }
            bindRequest
                .then(() => {
                    if (this.selectedType === 'nat') {
                        this.$message.success(this.$t('privateNetInstance.operateSuccess'));
                    }

                    this.doClose();
                    this.$emit('refreshList');
                })
                .catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        this.$message.error(json.errmsg);
                    } catch (ex) {
                        console.log(ex);
                    }
                })
                .finally(() => {
                    this.sureLoading = false;
                    this.doClose();
                });
        },
        // 清空表单
        doReset(formName) {
            this.$refs[formName].resetFields();
            this.selectedVpcId = '';
            this.selectedNatId = '';
        },
        // 修改搜索条件
        changeSearch() {
            const searchPlaceholder = this.$t('eip.placeholder.search');
            const currentSearchVar = this.currentSearch;
            this.currentPlaceholder = searchPlaceholder[currentSearchVar];
            // 清空当前搜索条件
            this.currentSearchValue = '';
        },
        // 获取VPC 实例列表数据
        getVpcListData() {
            // 基础参数
            if (this.region) {
                const param = {
                    pageSize: this.pageSize,
                    pageNumber: this.currentPage,
                    region: this.region,
                    networkType: NetworkTypeConstant.VPC,
                    //绑定的时候筛选运行中、已关机状态的实例才能绑定
                    status: 'running,stopped',
                    'interfaceMode': this.selectInternetAccessType,
                    chargeStatus: 'normal'
                };
                // 搜索部分添加参数
                const currentSearchInputValue = this.currentSearchValue;
                if (currentSearchInputValue !== '') {
                    switch (this.currentSearch) {
                        case 'name': {
                            Object.assign(param, { name: currentSearchInputValue })
                            break;
                        }
                        case 'id': {
                            param.instanceIds = this.currentSearchValue;
                            break;
                        }
                    }
                }
                this.refreshLoading = true;
                Ajax.get({
                    action: '/listInstances',
                    param,
                    success: (data) => {
                        this.refreshLoading = false;
                        const list = data.instances;
                        list.map((item, index) => {
                            item.index = index;
                            item.ipAddressOptions = [];
                            item.hasChecked = false;
                            item.selectedIpAddress = '';
                        })
                        this.vpcListData = list;
                        this.total = list.length;
                        this.resetSelectedVpcData();
                    },
                    fail() {
                        this.refreshLoading = false;
                    }
                });
            }
        },
        // 获取GAME 实例列表数据
        getGameListData() {
            // 基础参数
            if (this.region) {
                const param = {
                    instanceType: 'game',
                    pageSize: this.pageSize,
                    pageNumber: this.currentPage,
                    region: this.region,
                    networkType: NetworkTypeConstant.VPC,
                    status: 'running,stopped',
                    'interfaceMode': this.selectInternetAccessType,
                    chargeStatus: 'normal'
                };
                // 搜索部分添加参数
                const currentSearchInputValue = this.currentSearchValue;
                if (currentSearchInputValue !== '') {
                    switch (this.currentSearch) {
                        case 'name': {
                            Object.assign(param, { name: currentSearchInputValue })
                            break;
                        }
                        case 'id': {
                            param.instanceIds = this.currentSearchValue;
                            break;
                        }
                    }
                }
                this.refreshLoading = true;
                Ajax.get({
                    action: '/instances/listEipGameInstances',
                    param,
                    success: (data) => {
                        this.refreshLoading = false;
                        const list = data.instances;
                        const resultList = list.map(item => {
                            return {
                                ...item.instance,
                            }
                        });
                        resultList.map((item, index) => {
                            item.index = index;
                            item.ipAddressOptions = [];
                            item.hasChecked = false;
                            item.selectedIpAddress = '';
                        })
                        this.vpcListData = resultList;
                        this.total = resultList.length;
                        this.resetSelectedVpcData();
                    },
                    fail() {
                        this.refreshLoading = false;
                    }
                });
            }
        },
        // 根据搜索条件进行搜索
        filterBySearchValue() {
            this.getDifferentListDataBySelectedRadio();
        },
        // 根据VPC实例是否绑定EIP/SLB实例是否绑定EIP，添加不同样式
        tableRowClassName(row) {
            switch (this.selectedType) {
                //  case 'cps':{
                // if (row.enableInternet === EnableInternetConstant.YES) {
                //   return 'is-disabled';
                // }
                // break;
                //  }
                case 'slb': {
                    if (row.elasticIpId !== undefined) {
                        return 'is-disabled';
                    }
                    break;
                }
            }
        },
        // 区分当前是哪种实例类型，进行不同的列表请求
        getDifferentListDataBySelectedRadio() {
            switch (this.selectedType) {
                case 'cps': {
                    this.getVpcListData();
                    break;
                }
                case 'slb': {
                    this.getSlbListData();
                    break
                }
                case 'nat': {
                    this.getNatListData();
                    break
                }
                case 'game': {
                    this.getGameListData();
                    break;
                }
            }
        },
        // 获取负载均衡实例列表数据
        getSlbListData() {
            // 基础参数
            if (this.region) {
                const param = {
                    pageSize: this.pageSize,
                    pageNumber: this.currentPage,
                    region: this.region,
                    bindEip: false,
                    chargeStatus: 'normal'
                };
                // 搜索部分添加参数
                const currentSearchInputValue = this.currentSearchValue;
                if (currentSearchInputValue !== '') {
                    switch (this.currentSearch) {
                        // 名称
                        case 'name': {
                            Object.assign(param, { name: currentSearchInputValue })
                            break;
                        }
                        // ID
                        case 'id': {
                            Object.assign(param, { loadBalancerIds: currentSearchInputValue })
                            break;
                        }
                    }
                }
                this.refreshLoading = true;
                Ajax.get('/api/cps/listSlbs', param)
                    .then((res) => {
                        const data = res.data
                        this.slbListData = data.loadBalancers;
                        this.total = data.totalCount;
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.refreshLoading = false;
                    });
            }
        },

        // 获取nat网关实例列表数据
        getNatListData() {
            // 基础参数
            if (this.region) {
                const param = {
                    pageSize: this.pageSize,
                    pageNumber: this.currentPage,
                    region: this.region,
                    include: 'yes',
                    chargeStatus: 'normal'
                };
                // 搜索部分添加参数
                const currentSearchInputValue = this.currentSearchValue;
                if (currentSearchInputValue !== '') {
                    switch (this.currentSearch) {
                        // 名称
                        case 'name': {
                            Object.assign(param, { name: currentSearchInputValue })
                            break;
                        }
                        // ID
                        case 'id': {
                            Object.assign(param, { natGatewayIds: currentSearchInputValue })
                            break;
                        }
                    }
                }
                this.refreshLoading = true;
                Ajax.get('/api/cps/nat/queryNatGatewayPage', param)
                    .then((res) => {
                        const data = res.data
                        this.natListData = data.natGateways;
                        this.total = data.totalCount;
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.refreshLoading = false;
                    });
            }
        },
        // 切换资源类型
        changeSelectedType() {
            this.currentSearchValue = ''
            this.currentSearch = 'name';
            this.pageSize = 20;
            this.pageNumber = 1;
            this.getDifferentListDataBySelectedRadio()
        },
        changeSelectedIpAddress(row) {
            let selectedVpcData = {
                subnetId: row.subnetId,
                extensionSubnetId: row.extensionSubnetId,
                selectedIpAddress: row.selectedIpAddress
            }
            this.selectedVpcData = selectedVpcData;
        },
        resetSelectedVpcData() {
            this.selectedVpcData = {}
        }
    }
};
</script>

<style lang="scss">
@import '../../../assets/scss/paginationCommon.scss';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/components/eip/bindSource/BindSource.vue